(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2b9b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2b9b"] = parcelRequire;
}
parcelRequire.register("koP6R", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ed9db1dce57fbd45$export$6503ec6e8aabbaf; }, function (v) { return $ed9db1dce57fbd45$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ed9db1dce57fbd45$export$f7ad0328861e2f03; }, function (v) { return $ed9db1dce57fbd45$export$f7ad0328861e2f03 = v; });
var $ed9db1dce57fbd45$export$6503ec6e8aabbaf;
var $ed9db1dce57fbd45$export$f7ad0328861e2f03;
"use strict";
var $ed9db1dce57fbd45$var$mapping = {};
function $ed9db1dce57fbd45$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$ed9db1dce57fbd45$var$mapping[keys[i]] = pairs[keys[i]];
}
function $ed9db1dce57fbd45$var$resolve(id) {
    var resolved = $ed9db1dce57fbd45$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$ed9db1dce57fbd45$export$6503ec6e8aabbaf = $ed9db1dce57fbd45$var$register;
$ed9db1dce57fbd45$export$f7ad0328861e2f03 = $ed9db1dce57fbd45$var$resolve;

});

var $ce2fae16a46bdf6a$exports = {};

(parcelRequire("koP6R")).register(JSON.parse('{"d5I4I":"about.37ca787a.js","dxTjb":"sumatrancat.e50a4151.riv"}'));

})();
//# sourceMappingURL=about.5dbffec2.js.map
